module.exports = __webpack_public_path__ + "img/EFAM.26124ce9.png";